import { redirect } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth";
import { ROUTE_KEYS, ROUTES } from "../constants";

async function loginLoader({ request }) {
  let activeSession = false;
  try {
    const currentUser = await getCurrentUser();
    activeSession = !!currentUser?.username;
  } catch (error) {
    activeSession = false;
    return {
      activeSession
    }
  }

  if (activeSession) {
    const url = new URL(request.url);
    const cognitoCode = url.searchParams.get("code");
    const from = url.searchParams.get("from");
    const redirectPath = from ? decodeURIComponent(from) : "/";
    if (
      !cognitoCode &&
      !redirectPath?.startsWith(ROUTES[ROUTE_KEYS.LOGIN].path)
    ) {
      if(!url.pathname.startsWith(redirectPath)) {
        return redirect(redirectPath);
      }
    }
  }
  return { activeSession };
}

export default loginLoader;
